import { Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './Components/common/Navbar';
import ScrollToTop from './Components/common/ScrollToTop';
import Home from './pages/Home';
import Footer from './pages/Footer';
import Error from './pages/Error';
import AboutUs from './pages/AboutUs';
import Blog from './pages/Blog'
import Portfolio from './pages/Portfolio'
import ContactUs from './pages/ContactUs';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Faq from './pages/Faq';
import TermsAndCondition from './pages/TermsAndCondition';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';

function App() {
  return (
    <div className="App ">
     <ScrollToTop/>
     <Navbar/>
     <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='*' element={<Error/>} />
          <Route path='/aboutus' element={<AboutUs/>} />
          <Route path='/blog' element={<Blog/>} />
           <Route path='/portfolio' element={<Portfolio/>}/>
           <Route path='/contactus' element={<ContactUs/>}/>
           <Route path='/services' element={<Services/>} />
           <Route path='/services/:serviceName' element={<ServiceDetail/>} />
           <Route path='/faq' element={<Faq/>} />
           <Route path='/termsandcondition' element={<TermsAndCondition/>} />
           <Route path='/privacypolicy' element={<PrivacyPolicy/>} />
           <Route path='/cookiepolicy' element={<CookiePolicy/>} />

     </Routes>
     <Footer/>
    </div>
  );
}

export default App;
